export const apiConstants = {
  meals: '/ingredient/categories',
};
